// extracted by css-extract-rspack-plugin
export default {"toggleButtons":"kwWMZIGjMMiWpzIg","customButton":"IVkJ1ndZln0jzHCr"};